











































import { mapGetters, mapState } from 'vuex';
import { copyToClipBoard } from '@/helpers/copyToClipBoard';
import { getReadOnlyWidgetUrl } from '@/api/ClientInfo';
import type { PropType } from 'vue';
import type { UserDetails } from '@/api/schema';

interface DataMap {
  name: string;
  field: string;
  visible?: boolean;
  copy?: boolean;
}

export default {
  name: 'UserManagementDetails',
  props: {
    details: {
      type: Object as PropType<UserDetails>,
      default: (): UserDetails => {
        return {} as UserDetails;
      },
      required: true
    },
    loading: {
      type: Boolean as PropType<boolean>,
      default: (): boolean => true
    }
  },
  data(): Record<string, unknown> {
    return {
      widgetUrl: null
    };
  },
  computed: {
    ...mapGetters('Onboarding', ['isMobile', 'operatorId']),
    ...mapState('ClientsInfo', ['clientsInfo']),
    ...mapState('app', ['isSuperAdmin']),
    ...mapState('SuperAdmin', ['currentAccount']),
    dataMap(): DataMap[] {
      return [
        {
          name: 'Registration Date',
          field: 'createdAt'
        },
        {
          name: 'ID',
          field: 'id',
          visible: !this.isMobile,
          copy: true
        },
        {
          name: 'Operator User ID',
          field: 'operatorUserId',
          copy: true
        },
        {
          name: 'Wallet Address',
          field: 'walletHash',
          visible: !this.isMobile,
          copy: true
        },
        {
          name: 'KYC',
          field: 'kyc'
        }
      ].filter((item: DataMap): boolean => {
        return item.visible ?? true;
      });
    },
    needToShowWidgetUrl(): boolean {
      if (!this.isSuperAdmin) {
        return false;
      }

      if (this.currentAccount.copyStakeAccount) {
        return false;
      }

      return !!this.details?.id;
    },
    canGetWidgetUrl(): boolean {
      return !!this.needToShowWidgetUrl;
    },
    isWidgetUrlVisible(): boolean {
      return this.widgetUrl !== null;
    }
  },
  watch: {
    canGetWidgetUrl: {
      async handler(): Promise<void> {
        if (!this.canGetWidgetUrl) {
          return;
        }

        await this.getWidgetUrl();
      },
      immediate: true
    }
  },
  methods: {
    copyToClipBoard,
    async getWidgetUrl(): Promise<void> {
      if (!this.details.id) {
        return;
      }

      try {
        const { url } = await getReadOnlyWidgetUrl(this.details.id);

        this.widgetUrl = url || null;
      } catch (error) {
        console.error(error);
        this.widgetUrl = null;
      }
    }
  }
};
